import React from 'react';
import Header from '../components/Header';
import Home from './Home';
import About from './About';
import Contact from './Contact';
import Footer from '../components/Footer';
import MainProjects from '../components/MainProjects';
import '../css/pages/Pages.css';

function Index() {
  return (
    <div>
      <p
          className="warning-resolution"
        >
          To view this page, a minimum resolution of
          320x500 pixels is required.
      </p>
      <section className="section-index">
        <Header />
        <Home />
        <About />
        <MainProjects />
        <Contact />  
        <Footer />
      </section>
    </div>
  )
}

export default Index;
